export default __webpack_public_path__ + "static/media/twitter-icon-white.127b58ee.svg";